import type { ReactNode } from "react";

// Substitui variáveis no formato {{chave}} e processa marcação **bold** básica.
// Retorna uma lista de nós React para preservar formatação.
export function processMarkdownText(
  text: string,
  variables: Record<string, string>,
): ReactNode[] {
  let processedText = text;

  Object.entries(variables).forEach(([key, value]) => {
    const safeKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`\\{\\{${safeKey}\\}\\}`, "g");
    processedText = processedText.replace(regex, value);
  });

  // Divide preservando tokens **bold**
  const tokens = processedText.match(/\*\*.*?\*\*/g) ?? [];
  const result: ReactNode[] = [];
  let cursor = 0;
  let tokenIndex = 0;

  tokens.forEach((token) => {
    const index = processedText.indexOf(token, cursor);
    if (index > cursor) {
      result.push(processedText.slice(cursor, index));
    }
    const boldText = token.slice(2, -2);
    result.push(<b key={`bold-${tokenIndex}-${boldText}`}>{boldText}</b>);
    cursor = index + token.length;
    tokenIndex += 1;
  });
  if (cursor < processedText.length) {
    result.push(processedText.slice(cursor));
  }
  return result;
}
